// hooks/useCameraSettings.ts
import { useEffect, useState } from 'react';
function getCameraSettings(width) {
    if (width < 480) {
        // телефон — камера дальше, fov шире
        return { position: [28, 8, -12], fov: 40 };
    }
    if (width < 768) {
        // планшет
        return { position: [24, 7, -10], fov: 32 };
    }
    // десктоп — оригинальные настройки
    return { position: [20, 6, -8], fov: 25 };
}
export function useCameraSettings() {
    const [settings, setSettings] = useState(() => getCameraSettings(window.innerWidth));
    useEffect(() => {
        const handler = () => setSettings(getCameraSettings(window.innerWidth));
        window.addEventListener('resize', handler);
        return () => window.removeEventListener('resize', handler);
    }, []);
    return settings;
}
